import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useServicesSectionStyles } from '../styles/ServicesSection.styles';
import {
  useServiceData,
  BaseWeekHours,
  SpecialEventData,
  RecentlyEditedBaseHours,
} from '../hooks/useServiceData';
import { getTruncatedTextProps, getBorderRadiusStyles } from '../common/utils';

interface ServicesSectionProps {
  weekDays: Date[];
  baseWeekHours: BaseWeekHours;
  specialEventDayByDay: SpecialEventData[];
  is12HFormat: boolean;
  recentlyEditedBaseHours?: RecentlyEditedBaseHours;
}

function ServicesSection({
  weekDays,
  baseWeekHours,
  specialEventDayByDay,
  is12HFormat,
  recentlyEditedBaseHours = {},
}: ServicesSectionProps) {
  const classes = useServicesSectionStyles();

  const { services, getServiceDisplayInfo } = useServiceData({
    weekDays,
    baseWeekHours,
    specialEventDayByDay,
    is12HFormat,
    recentlyEditedBaseHours,
  });

  return (
    <div className={classes.sectionGroup}>
      {services.map((service, serviceIndex) => (
        <div
          key={service.key}
          className={
            serviceIndex === services.length - 1 ? '' : classes.serviceRow
          }
        >
          <div className={classes.weekGrid}>
            {weekDays.map((day, dayIndex) => {
              const {
                cardClass,
                isRecentlyEdited,
                displayText,
                specialEventClassName,
                strikethroughText,
              } = getServiceDisplayInfo(service.label, dayIndex);

              return (
                <div
                  key={`${service.key}-${dayIndex}`}
                  className={`${classes[cardClass]} ${classes.dayCard} ${isRecentlyEdited ? classes.highlightedCard : ''}`}
                  style={{
                    ...getBorderRadiusStyles(serviceIndex, services.length),
                    minWidth: 0,
                    width: '100%',
                  }}
                >
                  <div className={classes.serviceContent}>
                    {(() => {
                      const { displayText, tooltipTitle } =
                        getTruncatedTextProps(service.label);
                      return (
                        <Typography
                          className={`${classes.serviceName} ${classes.serviceNameContainer}`}
                          title={tooltipTitle}
                        >
                          {displayText}
                        </Typography>
                      );
                    })()}
                    <Typography component="div" className={classes.serviceTime}>
                      <>
                        <span
                          className={
                            specialEventClassName
                              ? classes[specialEventClassName]
                              : ''
                          }
                        >
                          {displayText}
                        </span>
                        {strikethroughText && (
                          <div className={classes.strikethroughText}>
                            {strikethroughText}
                          </div>
                        )}
                      </>
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ServicesSection;
